import { render, staticRenderFns } from "./FormLayoutPicker.vue?vue&type=template&id=23d47aec&scoped=true&lang=pug"
import script from "./FormLayoutPicker.vue?vue&type=script&lang=js"
export * from "./FormLayoutPicker.vue?vue&type=script&lang=js"
import style0 from "./FormLayoutPicker.vue?vue&type=style&index=0&id=23d47aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d47aec",
  null
  
)

export default component.exports